import { FC, useMemo, useState } from 'react';
import { Button } from 'common-components';
import styles from './tagForm.module.scss';
import { useTranslationContext } from '../../../contexts/translationContext';
import AdminInput from '../../input/input';
import Scroller from '../../scroller/scroller';

const TagFrom: FC<TagFormProps> = (props: TagFormProps) => {
    const { onCancel, onSave, categories, isEdit = false, tagName, tagId, tagCategories = [] } = props;
    const { translate } = useTranslationContext();

    const [currentTagName, setCurrentTagName] = useState<string | undefined>(tagName || '');
    const [selectedCategories, setSelectedCategories] = useState<string[]>(tagCategories);

    const Close = translate('Close');
    const CREATE = translate('Create');
    const CREATE_HEADER = translate('AddNewTag');
    const EDIT_HEADER = translate('EditTag');
    const TAG_NAME = translate('TagName');
    const INCLUDED_IN = translate('IncludedIn');
    const TYPE_ANYTHING = translate('TypeAnything');
    const SAVE = translate('Save');

    const onSaveHandler = () => {
        onSave({
            name: currentTagName || '',
            displayName: currentTagName || '',
            categoryIds: selectedCategories.map(category => parseInt(category, 10)),
            ...(tagId && { id: tagId })
        });
    };

    const categoriesMemo = useMemo(() => {
        return categories.map(category => ({
            name: category.categoryId.toString(),
            displayName: category.categoryName
        }));
    }, [categories]);

    const onChangeHandler = (_event: any, name: string) => {
        if (selectedCategories.includes(name)) {
            setSelectedCategories(selectedCategories.filter(category => category !== name));
        } else {
            setSelectedCategories([...selectedCategories, name]);
        }
    };

    const isFormValid = currentTagName && selectedCategories.length > 0;

    const HEADER = isEdit ? EDIT_HEADER : CREATE_HEADER;
    const BUTTON_TEXT = isEdit ? SAVE : CREATE;

    return (
        <div className={styles.container}>
            <div className={styles.content}>
                <div className={styles.header}>{HEADER}</div>
                <div className={styles['input-container']}>
                    <span className={styles['sub-header']}>{TAG_NAME}</span>
                    <AdminInput
                        onChange={setCurrentTagName}
                        placeholder={TYPE_ANYTHING}
                        defaultValue={currentTagName}
                    />
                </div>
                <div className={styles['input-container']}>
                    <span className={styles['sub-header']}>{INCLUDED_IN}</span>
                    <Scroller
                        items={categoriesMemo}
                        selectedItems={selectedCategories}
                        onChange={onChangeHandler}
                        maxHeight={'8rem'}
                    />
                </div>
            </div>
            <div className={styles.footer}>
                <Button onClick={onCancel} type="learningPanelAdminOnlyText" text={Close} lowerCase={true} />
                <Button
                    onClick={onSaveHandler}
                    type={isFormValid ? 'gradientNoBorder' : 'gradientNoBorderDisabled'}
                    text={BUTTON_TEXT}
                    lowerCase={true}
                />
            </div>
        </div>
    );
};

interface TagFormProps {
    onCancel: () => void;
    onSave: (tag: { name: string; displayName: string; categoryIds: number[]; id?: number }) => void;
    categories: { categoryId: number; categoryName: string }[];
    isEdit?: boolean;
    tagName?: string;
    tagId?: number;
    tagCategories?: string[];
}

export default TagFrom;
